import React from 'react';
import styles from './Button.module.css';
import { Link } from 'react-router-dom'; // Importé pour gérer les boutons qui sont des liens

function Button({ children, onClick, to, type = 'button', variant = 'primary' }) {
  const buttonClass = `${styles.button} ${styles[variant]}`;

  if (to) {
    return (
      <Link to={to} className={buttonClass}>
        {children}
      </Link>
    );
  }

  return (
    <button type={type} onClick={onClick} className={buttonClass}>
      {children}
    </button>
  );
}

export default Button;
